import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
    constructor() {}
}
